// Button install bonus content has priotity over content-driven messaging from merch portal for the button slide
import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { useGetBonusButton } from 'core/modules/BonusButton/hooks/useGetBonusButton';
import BonusButtonSlideMessage
  from 'core/modules/BonusButton/components/BonusButtonSlideMessage/BonusButtonSlideMessage';
import SlideMessage from 'core/modules/Onboarding/components/SlideMessage/SlideMessage';
import Cookies from 'js-cookie';

const isNewUser = Cookies.get('f') === 'true';

function SlideMessageButton({ step }) {
  const { isLoaded, placement } = useGetBonusButton(isNewUser);

  if (!isLoaded) return null;

  return placement ? <BonusButtonSlideMessage placement={placement} /> : <SlideMessage step={step} />;
}

export default (props) => <ComponentErrorBoundary><SlideMessageButton {...props} /></ComponentErrorBoundary>;
